<template>
  <div>
    <el-row v-loading="isLoadingSummary" class="cs-runningAccount-summary">
      <el-col v-for="item in summaryDataList" :key="item.Currency" :span="12"
        :class="`cs-runningAccount-summary-item item-${item.Currency}`">
        <el-row>
          <el-col class="cs-runningAccount-summary-title cs-color-frenchgrey">
            所有{{getCurrencyDesc(item.Currency)}}真留销售
          </el-col>
        </el-row>
        <el-row>
          <el-col class="cs-runningAccount-summary-totalAmount">
            {{ item.TotalSaleAmount | toCurrency(item.Currency) }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            手续费: {{ item.TotalServiceCharge | toCurrency(item.Currency) }}
          </el-col>
          <el-col :span="6">
            欠款: {{ item.TotalDebt | toCurrency(item.Currency) }}
          </el-col>
          <el-col :span="6">
            退款: {{ item.TotalRefund | toCurrency(item.Currency) }}
          </el-col>
          <el-col :span="6">
            未到账服务费: {{ item.TotalUnreceived | toCurrency(item.Currency) }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            总佣金: {{ item.TotalCommission | toCurrency(item.Currency) }}
          </el-col>
          <el-col :span="6">
            速成需付佣金: {{ item.TotalSpeedupCommission | toCurrency(item.Currency) }}
          </el-col>
          <el-col :span="6">
            渠道扣除佣金: {{ item.TotalChannelCommission | toCurrency(item.Currency) }}
          </el-col>
        </el-row>
        <el-row class="cs-color-frenchgrey">
          <el-col :span="18">
            (<span class="cs-totalFixedCommission">总固定佣金: {{ item.TotalFixedCommission | toCurrency(item.Currency) }}</span>
            <span>|</span>
            <span class="cs-totalRenewCommission">总续购佣金: {{ item.TotalRenewCommission | toCurrency(item.Currency) }}</span>)
          </el-col>
          <el-col v-if="item.Currency === GLOBAL.currencyType.CNY" :span="6">
            <el-button type="text" class="btn-details" @click="toggleProfitDetailVisible">
              <template>
                <i class="el-icon-caret-bottom" v-if="showProfitDetail">&nbsp;</i>
                <i class="el-icon-caret-right" v-else>&nbsp;</i>收益详情
              </template>
            </el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div v-loading="isLoadingSummary" v-show="showProfitDetail" class="cs-summary-profitDetail">
      <el-col v-for="item in summaryDataList" :key="item.Currency" :span="12" class="cs-summary-profitDetail-item">
        <table>
          <colgroup>
            <col width="50" />
            <col width="50" />
          </colgroup>
          <tr>
            <th>部门</th>
            <th>金额</th>
          </tr>
          <tr v-for="sapcItem in GLOBAL.enumStudyAbroadPriceCategory.getOptions()" :key="sapcItem.value">
            <td>{{sapcItem.desc}}</td>
            <td>{{Object.toCurrency(item.DepartmentProfit[sapcItem.key], item.DepartmentProfit.Currency)}}</td>
          </tr>
          <tr>
            <td>市场</td>
            <td>{{Object.toCurrency(item.DepartmentProfit.Marketing, item.DepartmentProfit.Currency)}}</td>
          </tr>
          <tr>
            <td>合计</td>
            <td>{{Object.toCurrency(item.DepartmentProfit.Total, item.DepartmentProfit.Currency)}}</td>
          </tr>
        </table>
      </el-col>
    </div>
    <el-row class="cs-filter-row">
      <el-col>
        <el-row :gutter="rowGutter">
          <el-col :span="filterSpan">
            <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search"
              v-model.trim="searchCondition.phone" @change="onSearchConditionChanged" @keyup.enter.native="onSearchClick">
            </el-input>
          </el-col>
          <el-col :span="filterSpan * 2" class="cs-datepick-col">
            <el-date-picker align="center" class="cs-accountList-searchDate" v-model="searchCondition.searchDate" type="daterange"
              unlink-panels range-separator="-" start-placeholder="开始" end-placeholder="结束" :picker-options="pickerOptions"
              size="medium" @change="onSearchConditionChanged"></el-date-picker>
          </el-col>
          <el-col :span="filterSpan">
            <el-select placeholder="大学" v-model="searchCondition.universityId" @change="onSearchConditionChanged" size="medium">
              <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" class="cs-saleQuery-buttons">
            <el-button size="medium" type="primary" @click="onSearchClick">搜索</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="rowGutter" class="margin-top-10">
          <el-col :span="filterSpan">
            <el-select placeholder="类型" v-model="searchCondition.status" @change="onSearchConditionChanged" size="medium">
              <el-option v-for="item in statusList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
            </el-select>
          </el-col>
          <el-col :span="filterSpan">
            <el-select placeholder="渠道" v-model="searchCondition.channelId" @change="onSearchConditionChanged" size="medium">
              <el-option v-for="item in channelList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
            </el-select>
          </el-col>
          <el-col :span="filterSpan">
            <el-select placeholder="收款类型" v-model="searchCondition.payeeType" @change="onSearchConditionChanged" size="medium">
              <el-option v-for="item in payeeTypeList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
            </el-select>
          </el-col>
          <el-col :span="filterSpan" v-if="searchCondition.payeeType == 1">
            <el-select placeholder="底价模式" v-model="searchCondition.bottomPriceType" @change="onSearchConditionChanged"
              size="medium">
              <el-option v-for="item in bottomPriceTypeList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
            </el-select>
          </el-col>
          <el-col :span="filterSpan">
            <el-select placeholder="服务费状态" v-model="searchCondition.serviceFeeStatus" @change="onSearchConditionChanged"
              size="medium">
              <el-option v-for="item in serviceFeeStatusList" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="rowGutter" class="margin-top-10">
          <el-col :span="filterSpan">
            <el-select placeholder="业务类型" v-model="searchCondition.businessType" @change="onSearchConditionChanged" size="medium">
              <el-option v-for="item in businessTypeList" :key="item.value" :label="item.desc" :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="filterSpan" v-if="USERMANAGER.isAdmin || USERMANAGER.isSAManager">
            <el-select placeholder="请选择" v-model="searchCondition.selectedEmployeeId" @change="onSearchConditionChanged" size="medium" filterable>
              <el-option :key="0" label="所有行政人员" :value="0"/>
              <el-option v-for="item in employeeListData" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <hr />

    <el-row class="grid-content">
      <el-col>
        <pagination v-loading="loading" :data="listData" :option="paginationOption" @search="search" @loadData="search"
          @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange" @edit="onTableEdit">
          <template #BusinessType="{row, col}">
            <span>{{GLOBAL.enumBusinessType.getDesc(row[col.Field])}}</span>
          </template>
        </pagination>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-runningAccount-summary {
  display: flex;

  .cs-runningAccount-summary-item {
    padding: 0 20px;
    border-right: 1px solid #ced3d9;

    &.item-1 {
      border-right: 0;
    }
  }
  .cs-runningAccount-summary-title {
  }
  .cs-runningAccount-summary-totalAmount {
    font-weight: bold;
    font-size: 30px;
  }
  .cs-totalFixedCommission {
    margin-right: 5px;
  }
  .cs-totalRenewCommission {
    margin-left: 5px;
  }

  .btn-details {
    padding: 0;
    display: block;
    margin-left: auto;
  }
}

.cs-summary-profitDetail {
  display: flex;
  margin-top: 20px;

  .cs-summary-profitDetail-item {
    padding: 0 20px;

    table {
      width: 100%;

      th {
        height: 30px;
        color: black;
        background-color: #c9c9c9;
      }

      th,
      td {
        padding: 10px;
      }
    }
  }
}

.cs-accountList-searchDate {
  width: 100%;
}
</style>

<script>
import pagination from "../common/pagination";
import { addMonth, formatDate, toDecimal } from "../../config/mUtils.js";
import { getUniversities } from "../../service/common.service";
import {
  getChannelItems,
  getRunningAccountSummary,
  getRunningAccountList,
} from "../../service/studyAbroad.service";
import { getEmployees } from "@/service/user.service";

export default {
  props: {},
  data() {
    return {
      rowGutter: 16,
      filterSpan: 4,
      searchCondition: {
        phone: "",
        searchDate: "",
        universityId: 0,
        channelId: 0,
        payeeType: -1,
        bottomPriceType: 0,
        status: 0,
        serviceFeeStatus: 0,
        businessType: 0,
        selectedEmployeeId: 0,
      },
      businessTypeList: [],
      employeeListData: [],
      currencyList: [
        this.GLOBAL.currencyType.CAD,
        this.GLOBAL.currencyType.CNY,
      ],
      universityList: [{ Key: 0, Value: "所有大学" }],
      channelList: [
        {
          Key: 0,
          Value: "所有销售渠道",
        },
      ],
      payeeTypeList: [
        {
          Key: -1,
          Value: "所有收款类型",
        },
        {
          Key: 0,
          Value: "速成收款",
        },
        {
          Key: 1,
          Value: "渠道收款",
        },
      ],
      bottomPriceTypeList: [
        {
          Key: 0,
          Value: "显示所有(底价模式)",
        },
        {
          Key: 1,
          Value: "底价模式",
        },
        {
          Key: 2,
          Value: "非底价模式",
        },
      ],
      statusList: [
        {
          Key: 0,
          Value: "所有缴付状态",
        },
        {
          Key: 1,
          Value: "欠款",
        },
        {
          Key: 2,
          Value: "退款",
        },
      ],
      serviceFeeStatusList: [
        {
          Key: 0,
          Value: "所有服务费到账状态",
        },
        {
          Key: 1,
          Value: "服务费已到账",
        },
        {
          Key: 2,
          Value: "服务费未到账",
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      loading: false,
      isLoadingSummary: false,
      showProfitDetail: false,
      listData: {},
      pageSize: 20,
      summaryDataList: [],
    };
  },
  components: {
    pagination,
  },
  created() {
    this.loadDropdownList();
    this.businessTypeList = JSON.parse(
      JSON.stringify(this.GLOBAL.enumBusinessType.getOptions())
    );
    this.businessTypeList.splice(0, 0, {
      key: 0,
      value: 0,
      desc: "所有业务类型",
    });

    this.paginationOption = {
      displayPagination: true,
      hasEditButton: true,
      editButtonText: "查看详情",
      hasAddButton: false,
      hasSearch: false,
      hasDateSearch: false,
      buttonWidth: 100,
    };
    this.searchCondition.searchDate = [];
    let today = new Date();
    this.searchCondition.searchDate.push(today);
    this.searchCondition.searchDate.push(today);
    this.search();
    this.init();
  },
  methods: {
    init() {},
    getCurrencyDesc(currency) {
      if (currency == this.GLOBAL.currencyType.CAD) {
        return "加币(CAD)";
      } else {
        return "人民币(CNY)";
      }
    },
    loadDropdownList() {
      getUniversities().then((result) => {
        if (!!result && result.success) {
          this.universityList = this.universityList.concat(result.data);
        }
      });
      getChannelItems().then((result) => {
        if (!!result && result.success) {
          this.channelList = this.channelList.concat(result.data);
        } else {
          this.channelList = [
            {
              Key: "",
              Value: "所有销售渠道",
            },
          ];
        }
      });
      this.getEmployeeListData();
    },
    toggleProfitDetailVisible() {
      this.showProfitDetail = !this.showProfitDetail;
    },
    onSearchConditionChanged() {},
    onSearchClick() {
      this.search();
    },
    search(pageData) {
      let searchData = this.getSearchPageData(pageData);
      this.loadRunningAccountListData(searchData);
      this.loadSummaryData(searchData);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageData) {
      if (typeof pageData == "undefined" || pageData == 1) {
        pageData = {
          pageNumber: 1,
        };
      }

      let startDate = "";
      let endDate = "";
      if (
        !!this.searchCondition.searchDate &&
        this.searchCondition.searchDate.length == 2
      ) {
        startDate = formatDate(this.searchCondition.searchDate[0]);
        endDate = formatDate(this.searchCondition.searchDate[1]);
      }

      let additionalFilter = {
        universityId: this.searchCondition.universityId,
        channelId: this.searchCondition.channelId,
        payeeType: this.searchCondition.payeeType,
        bottomPriceType: this.searchCondition.bottomPriceType,
        status: this.searchCondition.status,
        serviceFeeStatus: this.searchCondition.serviceFeeStatus,
        businessType: this.searchCondition.businessType,
        employeeId: this.searchCondition.selectedEmployeeId,
      };
      let searchData = {
        pageSize: this.pageSize,
        keyWord: this.searchCondition.phone,
        startDate: startDate,
        endDate: endDate,
        additionalFilter: additionalFilter,
      };
      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },
    loadRunningAccountListData(pageData) {
      this.loading = true;
      getRunningAccountList(pageData)
        .then((result) => {
          if (result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    loadSummaryData(pageData) {
      this.isLoadingSummary = true;
      getRunningAccountSummary(pageData)
        .then((result) => {
          if (result && result.success) {
            this.summaryDataList = result.data;
          }
          this.isLoadingSummary = false;
        })
        .catch((error) => {
          this.isLoadingSummary = false;
        });
    },
    onTableEdit(index, row) {
      let navList = JSON.stringify([this.$route.path]);

      this.$router.push({
        path: "/studyAbroad/accountDetail",
        query: {
          workflowId: row.WorkflowId,
          navList: this.$cryptoJS.enc.Base64.encode(navList),
        },
      });
    },
    loadAccountListData(pageData) {
      this.loading = true;
      getAccountList(pageData)
        .then((result) => {
          if (result && result.success) {
            this.listData = result.data;
            this.originalListData = JSON.parse(JSON.stringify(this.listData));
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    async getEmployeeListData() {
      let roleTypes = this.GLOBAL.roleType
        .getOptionsByKeys([
          "saBusinessSales",
          "saBusinessAssistant",
          "saBusinessManager",
          "saFinancialAssistant",
          "saFinancialManager",
        ])
        .map((enumOption) => enumOption.value);

      let result = await getEmployees(roleTypes, "", null);
      if (result && result.success) {
        this.employeeListData = result.data.Results.map((i) => {
          return { Id: i.UserId, Name: i.Name };
        });
      } else {
        this.employeeListData = [];
      }
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/runningAccountList.vue